<template>
  <v-flex data-qa="homecards-flex-erquzl">
    <Loader v-if="loaderEnabled" />
    <v-layout class="px-2" wrap data-qa="homecards-layout-tg3bck">
      <v-toolbar-title v-if="config.cardLabels" class="font-weight-light pt-1" data-qa="homecards-toolbar-title-t4rl6j">
        {{ config.title }} <font v-if="showTotalAccounts">({{ config.accounts.length }})</font>
        <!-- TODO DOB-355 {{ config.noticeAccountsTitle || config.title}} ({{ config.accounts.length }}) -->
      </v-toolbar-title>
      <v-spacer data-qa="homecards-spacer-l26j6b"></v-spacer>
      <v-btn
        v-if="viewMore && config.accounts.length > 2"
        class="text-capitalize overline font-weight-bold"
        :color="secondaryColor"
        @click="showMore()"
        text
       data-qa="homecards-btn-tqfr6v">
        {{ $t("homeCards.showMore") }}
      </v-btn>
      <v-btn
        v-if="viewLess && config.accounts.length > 2"
        class="overline font-weight-bold text-capitalize"
        :color="secondaryColor"
        @click="showLess()"
        text
       data-qa="homecards-btn-167xv5">
        {{ $t("homeCards.showLess") }}
      </v-btn>
    </v-layout>
    <OverallSubscriptionIsa v-if="showOverallSubscriptionIsa"/>
    <v-layout class="px-2" wrap data-qa="homecards-layout-ih9h2k">
      <v-flex
        v-for="(account, index) in accountDetails"
        :key="account.accountId"
        xs12
        sm12
        md6
        lg6
        xl6
        class="pa-2"
       :data-qa="`homecards-flex-fttnjc-${index}`">
        <v-card
          elevation="2"
          class="homeCards--cardsHeight"
          :style="checkForInactiveAccounts(account) ? inactiveCards : ''"
         data-qa="homecards-card-2xk41h">
          <v-container fluid class="pb-1" data-qa="homecards-container-c08nh">
            <v-layout
              @click="handleClick(account, 'view', index)"
              wrap
              class="px-3 home-cards--iconPointers"
             data-qa="homecards-layout-dt1zje">
              <v-flex xs2 sm2 md2 lg2 xl1 data-qa="homecards-flex-12vdbc">
                <inline-svg
                  class="mt-2"
                  :src="getNavigationIcon(config.title)"
                  width="40"
                  height="40"
                  aria-label="Navigation Icon"
                ></inline-svg>
              </v-flex>
              <v-flex
                v-if="config.title === $t('common.depositTypeLabel') || config.title === $t('common.savingsSubTitle_3')"
                class="mx-2 my-2"
                xs8
                sm8
                md8
                lg9
                xl9
               data-qa="homecards-flex-yans8h">
                <span class="pb-2 subtitle-2 font-weight-light" data-qa="homecards-span-ibaa1d">{{
                  $t("homeCards.TdBalance")
                }}</span>
                <br data-qa="homecards-br-frj0ph"  />
                <font
                  class="font-weight-bold text-h5"
                  :color="
                    $formatter.currency.isNegativeBalance(
                      account.currentBalance.value
                    )
                      ? errorColor
                      : ''
                  "
                  >{{
                    getBalInfo(
                      account.currentBalance.value,
                      account.status,
                      account.currency
                    )
                  }}</font
                >
                <br data-qa="homecards-br-y7p51"  />
                <v-flex class="mt-2" data-qa="homecards-flex-d68fv">
                  <span class="pb-2 subtitle-2 font-weight-light" data-qa="homecards-span-wy3buu">{{
                    $t("homeCards.maturityBalance")
                  }}</span>
                  <br data-qa="homecards-br-86h65e"  />
                  <font
                    class="font-weight-bold text-h5"
                    :color="
                      $formatter.currency.isNegativeBalance(
                        account.maturityAmount.value
                      )
                        ? errorColor
                        : ''
                    "
                    >{{
                      $formatter.currency.format(
                        account.maturityAmount.value,
                        account.currency
                      )
                    }}</font
                  >
                </v-flex>
                <v-progress-linear
                  class="mt-3 mb-1"
                  :color="warningColor"
                  height="4"
                  :value="
                    remainingMaturityDays(
                      account.startDate,
                      account.maturityDate,
                      account.status
                    )
                  "
                 data-qa="homecards-progress-linear-ahrrgf"></v-progress-linear>
                <span class="pb-2 subtitle-2 font-weight-medium" data-qa="homecards-span-yq1o9t">
                  {{ $t("homeCards.maturity") }}
                  {{ $formatter.formatDate(account.maturityDate) }} |
                  {{ $t("homeCards.term") }} {{ account.tenor.value }}
                  {{
                    getTenorDetails(
                      account.tenor.value,
                      account.tenor.frequency
                    )
                  }}
                  | {{ $t("homeCards.rateOfInterest") }}
                  {{ $formatter.formatInterstRate(account.interestRate) }}%
                </span>
              </v-flex>
              <v-flex
                v-if="
                  (config.title === $t('common.savingsTypeLabel') || config.title === $t('common.savingsSubTitle_1') || config.title === $t('common.savingsSubTitle_2')) ||
                  config.title === $t('common.currentTypeLabel') ||
                  config.title === $t('common.noticeTypeLabel')
                "
                class="mx-2 my-2"
                xs8
                sm8
                md8
                lg8
                xl8
               data-qa="homecards-flex-7n81dn">
                <span class="pb-2 subtitle-2 font-weight-light" data-qa="homecards-span-j9zkj">{{
                  $t("homeCards.availableBalance")
                }}</span>
                <br data-qa="homecards-br-83lnij"  />
                <font
                  class="font-weight-bold text-h5"
                  :color="
                    $formatter.currency.isNegativeBalance(account.balance)
                      ? errorColor
                      : ''
                  "
                  >{{
                    getBalInfo(
                      account.balance,
                      account.accountStatus,
                      account.currency
                    )
                  }}</font
                >
              </v-flex>
              <v-flex
                v-if="config.title === $t('common.creditTypeLabel')"
                class="mx-2 my-2"
                xs8
                sm8
                md8
                lg8
                xl8
               data-qa="homecards-flex-b9ox7d">
                <span class="pb-2 subtitle-2 font-weight-light" data-qa="homecards-span-7xw0ns">{{
                  $t("homeCards.availableBalance")
                }}</span>
                <br data-qa="homecards-br-lrxe82"  />
                <font
                  class="font-weight-bold text-h5"
                  :color="
                    $formatter.currency.isNegativeBalance(
                      account.outstandingBalance.amount
                    )
                      ? errorColor
                      : ''
                  "
                  >{{
                    getBalInfo(
                      account.outstandingBalance.amount,
                      account.cardStatus === "Active"
                        ? "ACTIVATED"
                        : account.cardStatus,
                      account.outstandingBalance.currency
                    )
                  }}
                </font>
              </v-flex>
              <v-flex
                v-if="config.title === $t('common.debitTypeLabel')"
                class="mx-2 my-2"
                xs8
                sm8
                md8
                lg8
                xl8
               data-qa="homecards-flex-0s25gr">
                <font class="font-weight-bold text-h6">
                  {{ account.accountNumber }} | {{ account.maskedDebitCardNumber }}
                </font>
                <br data-qa="homecards-br-of6z6u" />
                <font class="subtitle-2 font-weight-medium">
                  {{
                    account.cardHolderName
                  }}
                </font>
              </v-flex>
              <v-flex
                v-if="config.title === $t('common.loanLabel')"
                class="mx-2 my-2"
                xs8
                sm8
                md8
                lg8
                xl8
               data-qa="homecards-flex-yh059">
                <span class="pb-2 subtitle-2 font-weight-light" data-qa="homecards-span-azq6fx">{{
                  $t("homeCards.outstandingBalance")
                }}</span>
                <br data-qa="homecards-br-ovmpi"  />
                <font
                  class="font-weight-bold text-h5"
                  :color="
                    $formatter.currency.isNegativeBalance(
                      account.loanOutstandingAmount.amount
                    )
                      ? errorColor
                      : ''
                  "
                  >{{
                    $formatter.currency.format(
                      account.loanOutstandingAmount.amount,
                      account.loanOutstandingAmount.currency
                    )
                  }}</font
                >
                <br data-qa="homecards-br-vos2ch"  />
                <v-flex class="mt-2" data-qa="homecards-flex-dd5jtl">
                  <span class="pb-2 subtitle-2 font-weight-light" data-qa="homecards-span-mm74u1">
                    {{ $t("homeCards.maturity") }}
                    {{ $formatter.formatDate(account.maturityDate) }}
                  </span>
                </v-flex>
              </v-flex>
              <v-flex
                v-if="config.title === $t('common.mortgageAgreementLabel')"
                class="mx-2 my-2"
                xs8
                sm8
                md8
                lg8
                xl8
               data-qa="homecards-flex-sue0gc">
                <span class="pb-2 subtitle-2 font-weight-light" data-qa="homecards-span-eu3hqq">{{
                  $t("homeCards.outstandingBalance")
                }}</span>
                <br data-qa="homecards-br-v6nk8g"  />
                <font
                  class="font-weight-bold text-h5"
                  :color="
                    $formatter.currency.isNegativeBalance(
                      account.options[0].value.amount
                    )
                      ? errorColor
                      : ''
                  "
                  >{{
                    $formatter.currency.format(
                      account.options[0].value.amount,
                      account.options[0].value.currency
                    )
                  }}</font
                >
                <br data-qa="homecards-br-3xt1s"  />
                <span
                  v-if="account.options[0].type !== 'loanAgreementId'"
                  class="py-2 subtitle-2 font-weight-light"
                 data-qa="homecards-span-28f1cs">
                  {{ $t("homeCards.maturity") }}
                  {{ $formatter.formatDate(account.options[0].maturityDate) }}
                </span>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider data-qa="homecards-divider-00jcvo"  v-if="config.title != $t('common.debitTypeLabel')" class="mx-2 pa-0" />
          <v-row
            v-if="config.title !== $t('common.mortgageAgreementLabel')"
            class="ml-4 mr-2"
            dense
           data-qa="homecards-row-qaupfn">
            <span
              v-if="config.title === $t('common.depositTypeLabel') || config.title === $t('common.savingsSubTitle_3')"
              class="my-3 mx-4 subtitle-2 font-weight-medium"
             data-qa="homecards-span-ilcujc">
              <font class="body-1 font-weight-bold"
                >{{ $formatter.formatAccount(account.accountId, account.iban) }}
              </font>
              | {{ getAccountStatus(account.status, config.title) }} |
              <font class="">{{
                account.productDescription
              }}</font>
            </span>
            <span
              v-else-if="config.title === $t('common.creditTypeLabel')"
              class="my-3 mx-4 subtitle-2 font-weight-medium"
             data-qa="homecards-span-9iedbb">
              <font class="body-1 font-weight-bold"
                >{{ account.maskedCreditCardNumber }}
              </font>
              | {{ account.cardHolderName }} |
              <font class="">{{
                account.creditCardProductName
              }}</font>
            </span>
            <span
              v-else-if="config.title === $t('common.debitTypeLabel')"
              class="pa-0 ma-0"
             data-qa="homecards-span-w48hx">
            </span>
            <span
              v-else-if="config.title === $t('common.loanLabel')"
              class="my-3 mx-4 subtitle-2 font-weight-medium"
             data-qa="homecards-span-skp1o">
              <font class="body-1 font-weight-bold">{{ account.loanId }} </font>
              | {{ account.productName }}
            </span>
            <span class="my-1 mx-4" v-else data-qa="homecards-span-zu3x6e">
              <div class="text-body-2" data-qa="homecards-div-4fhory">
                <span data-qa="homecards-span-eesw7a"
                  class="font-weight-bold text-body-1"
                  v-text="$formatter.formatAccount(account.accountId, account.iban)"
                />
                |
                <span data-qa="homecards-span-oekx4o"
                  :class="checkForInactiveAccounts(account) ? 'font-weight-bold' : ''"
                  v-text="getAccountStatus(account.accountStatus, config.title)"
                />
                <span data-qa="homecards-span-yud9p5"  v-text="getAccountText(account)" />
              </div>
            </span>
          </v-row>
          <v-row
            v-if="config.title === $t('common.mortgageAgreementLabel')"
            class="ml-4 mr-2"
            dense
           data-qa="homecards-row-5b83d">
            <span class="my-3 mx-4 subtitle-2 font-weight-medium" data-qa="homecards-span-5fc4j">
              <font
                v-if="account.options[0].type === 'loanAgreementId'"
                :key="account.options[0].id"
              >
                <font class="body-1 font-weight-bold">{{
                  account.options[0].id
                }}</font>
                ({{ $t("homeCards.mortgageNumber") }})
              </font>
              <font v-else class="font-weight-medium">
                <font class="body-1 font-weight-bold"
                  >{{ account.options[0].id }}
                </font>
                | {{ account.options[0].productName }}
              </font>
            </span>
          </v-row>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        sm12
        md6
        lg6
        xl6
        v-if="config.accounts.length < 2 && config.openNewACCard"
        class="pa-4 pl-0 pt-2"
       data-qa="homecards-flex-hbelu">
        <v-card elevation="2" class="homeCards--cardsHeight" data-qa="homecards-card-yazmel">
          <v-container fluid class="pb-1" data-qa="homecards-container-i3ge8t">
            <v-layout wrap class="px-3" data-qa="homecards-layout-966hxd">
              <v-flex xs2 sm2 md2 lg2 xl1 data-qa="homecards-flex-qgl3pr">
                <inline-svg
                  class="mt-4"
                  :src="getNavigationIcon(config.title)"
                  width="40"
                  height="40"
                  aria-label="Navigation Icon"
                ></inline-svg>
              </v-flex>
              <v-flex
                v-if="config.title === $t('common.depositTypeLabel') || config.title === $t('common.savingsSubTitle_3')"
                xs10
                sm10
                md10
                lg10
                xl10
               data-qa="homecards-flex-v1hxgg">
                <span class="font-weight-bold"
                   data-qa="homecards-span-mk9k6">{{ $t("homeCards.depositCardTitle") }}
                </span>
                <br data-qa="homecards-br-r1ockh"  />
                <span class="pb-2 subtitle-2 font-weight-medium" data-qa="homecards-span-wj03ah">{{
                  $t("homeCards.depositCardSubTitle")
                }}</span>
              </v-flex>
              <v-flex
                v-else-if="config.title === $t('common.currentTypeLabel')"
                xs10
                sm10
                md10
                lg10
                xl10
               data-qa="homecards-flex-lv66d">
                <span class="font-weight-bold"
                   data-qa="homecards-span-ylnvo">{{ $t("homeCards.currentCardTitle") }}
                </span>
                <br data-qa="homecards-br-tqod5m"  />
                <span class="pb-2 subtitle-2 font-weight-medium" data-qa="homecards-span-tlg9t7">{{
                  $t("homeCards.currentCardSubTitle")
                }}</span>
              </v-flex>
              <v-flex v-else xs10 sm10 md10 lg10 xl10 data-qa="homecards-flex-x2brld">
                <span class="font-weight-bold"
                   data-qa="homecards-span-f1o59j">{{ $t("homeCards.savingsCardTitle") }}
                </span>
                <br data-qa="homecards-br-nyg6f9"  />
                <span class="pb-2 subtitle-2 font-weight-medium" data-qa="homecards-span-2ps6bh">{{
                  $t("homeCards.savingsCardSubTitle")
                }}</span>
              </v-flex>
            </v-layout>
          </v-container>
          <v-row dense data-qa="homecards-row-ixjjf9">
            <v-spacer data-qa="homecards-spacer-3av93"  />
            <v-btn
              class="font-weight-bold"
              :color="primaryColor"
              @click="openAccount(config)"
              text
             data-qa="homecards-btn-bpknga">
              {{ $t("homeCards.openNow") }}
            </v-btn>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import '@/styles/pages/home/homeCards.scss'
import event from '@/util/event'
import _ from 'lodash'
import Loader from '../../components/common/Loader.vue'
import OverallSubscriptionIsa from '@/views/home/OverallSubscriptionIsa.vue'

export default {
  name: 'HomeCards',
  components: {
    Loader,
    OverallSubscriptionIsa
  },
  props: {
    config: {
      type: Object,
      default: undefined
    },
    showOverallSubscriptionIsa: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loaderEnabled: false,
      disableCard: false,
      viewMore: true,
      viewLess: false,
      accountDetails: [],
      closeOnClick: true,
      inactiveCards: {
        opacity: 0.5
      },
      showTotalAccounts: this.$appSettings.defaultConfigurations.landingPageConfig.showTotalAccounts,
      showAccountName: this.$appSettings.uiFieldsDisplayConfigurations.template.showAccountName
    }
  },
  created () {
    event.$on('updateCards', (data) => {
      this.accountDetails = []
      this.accountDetails = data.slice(0, 2)
    })
  },
  mounted () {
    this.accountDetails = []
    if (this.config.accounts && this.config.accounts.length) {
      this.accountDetails = this.config.accounts.slice(0, 2)
    }
    if (this.config.enableShowMore) {
      this.expandShowMore()
    }
  },
  methods: {
    handleClick (item, action, idx) {
      this[action](item, action, idx)
    },
    view (item, action, idx) {
      if (item.accountStatus === 'CLOSED' && item.accountType === 'NACC') {
        this.dispatchError(this.$t('homeCards.noAccountDetails', { account: item.accountId }))
      }
      const data = !!(item && item.loanId)
      if (item && item.cardId) {
        if (this.config.title === this.$t('common.creditTypeLabel')) {
          this.$router.push({
            name: 'CardDetails',
            params: {
              cardDetails: item,
              cardType: 'credit',
              cardId: item.cardId,
              cardName: item.cardHolderName,
              cardMaskedNumber: item.maskedCreditCardNumber,
              cardBalance: item.outstandingBalance.amount,
              cardCurrency: item.outstandingBalance.currency,
              cardProductName: item.creditCardProductName,
              cardStatus: item.accountType,
              cardExpiryDate: item.expiryDate,
              cardAccountNumber: item.accountNumber
            }
          })
        } else {
          this.$router.push({
            name: 'CardDetails',
            params: {
              cardDetails: item,
              cardType: 'debit',
              cardId: item.cardId,
              cardName: item.cardHolderName,
              cardMaskedNumber: item.maskedDebitCardNumber,
              cardProductName: item.debitCardProductName,
              cardStatus: item.cardStatus,
              cardExpiryDate: item.expiryDate,
              cardAccountNumber: item.accountNumber
            }
          })
        }
      } else if (item && !item.accountId) {
        if (item && item.options ? item.options.length && item.options[0].type === 'loanId' : false) {
          this.$router.push({
            name: 'LoanDetails',
            params: {
              loanId: data ? item.loanId : item.options[0].id,
              loanOutstandingAmount: data ? item.loanOutstandingAmount : item.options[0].value.amount,
              amount: data ? item.amount : item.options[0].value.amount,
              currency: data ? item.currency : item.options[0].value.currency
            }
          })
        } else {
          if (item && item.options ? window.location.pathname === '/home' || window.location.pathname === '/mortgageAgreementList' : false) {
            // Specific Mortgage Agreement Screen
            this.$router.push({
              name: 'Mortgage',
              params: {
                loanId: item.options[0].id,
                mortgageID: item.options[0].id,
                loanOutstandingAmount: item.options[0].value.amount,
                amount: item.options[0].value.amount,
                currency: item.options[0].value.currency
              }
            })
          } else {
            this.$router.push({
              name: 'LoanDetails',
              params: {
                customerId: item.customerId,
                loanId: item.loanId,
                loanOutstandingAmount: item.loanOutstandingAmount,
                amount: item.amount,
                currency: item.currency
              }
            })
          }
        }
      } else {
        let componentName = ''
        componentName = 'AccountDetails'
        this.$router.push({
          name: componentName,
          params: {
            product: item,
            balance: item.balance,
            clearedBalance: item.clearedBalance,
            currency: item.currency,
            accountId: item.accountId,
            accountName: item.customerName,
            accountType: item.accountType,
            accountOwnership: item.accountOwnership,
            accountStatus:
              (this.config.title === this.$t('common.depositTypeLabel') || this.config.title === this.$t('common.savingsSubTitle_3'))
                ? item.status
                : item.accountStatus
          }
        })
      }
    },
    amend (item, action, idx) {
      this.$router.push({
        name: 'TermDepositActions',
        params: {
          product: item,
          action: 'amend',
          accountType: item.accountType,
          routeFrom: location.pathname
        }
      })
    },
    break (item, action, idx) {
      this.$router.push({
        name: 'TermDepositActions',
        params: {
          product: item,
          action: 'break',
          accountType: item.accountType,
          routeFrom: location.pathname
        }
      })
    },
    getNavigationIcon (icon) {
      let resultIcon
      switch (icon) {
        case this.$t('common.savingsTypeLabel'):
        case this.$t('common.savingsSubTitle_1'):
        case this.$t('common.savingsSubTitle_2'):
        case this.$t('common.noticeTypeLabel'):
          resultIcon = this.getSvgIconSrc('Savings2')
          break
        case this.$t('common.currentTypeLabel'):
          resultIcon = this.getSvgIconSrc('Current2')
          break
        case this.$t('common.depositTypeLabel'):
          resultIcon = this.getSvgIconSrc('Deposit2')
          break
        case this.$t('common.savingsSubTitle_3'):
          resultIcon = this.getSvgIconSrc('Deposit2')
          break
        case this.$t('common.loanLabel'):
        case this.$t('common.mortgageAgreementLabel'):
          resultIcon = this.getSvgIconSrc('Loan_Dashboard')
          break
        case this.$t('common.creditTypeLabel'):
          resultIcon = this.getSvgIconSrc('credit2')
          break
        case this.$t('common.debitTypeLabel'):
          resultIcon = this.getSvgIconSrc('debit2')
          break
        default:
          break
      }
      return resultIcon
    },
    showMore () {
      if (window.location.pathname === '/home') { // current location path
        switch (this.config.title) {
          case this.$t('common.savingsTypeLabel'):
            this.$router.push({
              name: 'Savings Account',
              params: { from: 'Dashboard' }
            })
            break
          case this.$t('common.savingsSubTitle_1'):
            this.$router.push({
              name: 'Savings Account',
              params: { from: 'Dashboard' }
            })
            break
          case this.$t('common.savingsSubTitle_2'):
            this.$router.push({
              name: 'CashIsaAccount',
              params: { from: 'Dashboard' }
            })
            break
          case this.$t('common.currentTypeLabel'):
            this.$router.push({
              name: 'Current Account',
              params: { from: 'Dashboard' }
            })
            break
          case this.$t('common.depositTypeLabel'):
            this.$router.push({
              name: 'Deposits',
              params: { from: 'Dashboard' }
            })
            break
          case this.$t('common.savingsSubTitle_3'):
            this.$router.push({
              name: 'Deposits',
              params: { from: 'Dashboard' }
            })
            break
          case this.$t('common.loanLabel'):
            this.$router.push({
              name: 'Loan',
              params: { from: 'Dashboard' }
            })
            break
          case this.$t('common.mortgageAgreementLabel'):
            this.$router.push({
              name: 'MortgageAgreementList',
              params: { from: 'Dashboard' }
            })
            break
          case this.$t('common.creditTypeLabel'):
            this.$router.push({
              name: 'CreditCard',
              params: { from: 'Dashboard' }
            })
            break
          case this.$t('common.debitTypeLabel'):
            this.$router.push({
              name: 'DebitCard',
              params: { from: 'Dashboard' }
            })
            break
          default:
            this.$router.push({
              name: 'Savings Account',
              params: { from: 'Dashboard' }
            })
            break
        }
      } else {
        this.expandShowMore()
      }
    },
    expandShowMore () {
      this.accountDetails = [
        ...this.accountDetails,
        ...this.config.accounts.slice(2)
      ]
      this.viewMore = false
      this.viewLess = true
    },
    showLess () {
      this.accountDetails = this.accountDetails.slice(0, 2)
      this.viewMore = true
      this.viewLess = false
    },
    openAccount (config) {
      switch (this.config.title) {
        case this.$t('common.savingsTypeLabel'):
          this.$router.push('/savingsProducts')
          break
        case this.$t('common.savingsSubTitle_1'):
          this.$router.push('/savingsProducts')
          break
        case this.$t('common.savingsSubTitle_2'):
          this.$router.push('/savingsProducts')
          break
        case this.$t('common.currentTypeLabel'):
          this.$router.push('/currentProducts')
          break
        default:
          this.$router.push('/depositsProducts')
      }
    },
    getBalInfo (bal, status, currency) {
      if (bal !== undefined && bal.toString().trim().length > 0) {
        this.disableCard = false
        if (isNaN(bal)) {
          return bal
        } else {
          return this.$formatter.currency.format(bal, currency)
        }
      } else {
        this.disableCard = true
        if (!bal && status === 'ACTIVATED') {
          return this.$t('myAccounts.balanceInquiryRestricted')
        } else {
          return this.$t('homeCards.noBalance')
        }
      }
    },
    getAccountStatus (status, accountType) {
      return (accountType === this.$t('common.depositTypeLabel') || accountType === this.$t('common.savingsSubTitle_3'))
        ? this.$t(`systemEnums.termDeposit.${status}`)
        : this.$t(`systemEnums.casa.${status}`)
    },
    getTenorDetails (term, frequency) {
      return parseInt(term) > 1
        ? `${_.capitalize(frequency)}s`
        : _.capitalize(frequency)
    },
    remainingMaturityDays (date1, date2, accountStatus) {
      if (accountStatus === 'MATURED') {
        return '100'
      }
      const todaysDate = new Date()
      const formatDate1 =
        date1.length > 10 ? date1.toString().substring(0, 10) : date1
      const formatDate2 =
        date2.length > 10 ? date2.toString().substring(0, 10) : date2
      const formattedStartDate = this.$formatter
        .formatDate(formatDate1)
        .split('-')
        .join('/')
      const formattedMaturityDate = this.$formatter
        .formatDate(formatDate2)
        .split('-')
        .join('/')
      const startDate = new Date(
        `${formattedStartDate.split('/')[1]} / ${
          formattedStartDate.split('/')[0]
        } / ${formattedStartDate.split('/')[2]}`
      )
      const currentDate = new Date(todaysDate.toLocaleDateString())
      const endDate = new Date(
        `${formattedMaturityDate.split('/')[1]} / ${
          formattedMaturityDate.split('/')[0]
        } / ${formattedMaturityDate.split('/')[2]}`
      )
      const diffTime = Math.abs(endDate - startDate)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      const diffInCurrentTime = Math.abs(endDate - currentDate)
      const diffInCurrentDays = Math.ceil(
        diffInCurrentTime / (1000 * 60 * 60 * 24)
      )
      const coveredDays = diffDays - diffInCurrentDays
      const result = (coveredDays / diffDays) * 100
      return result.toString().includes('-') ? '100' : result
    },
    checkForInactiveAccounts (account) {
      if (
        account.accountStatus === 'INACTIVE' ||
        account.accountStatus === 'DEACTIVATED'
      ) {
        return true
      }
      return false
    },
    dispatchError (content) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title: 'Warning',
          content,
          type: 'error',
          width: 400,
          persistent: true,
          close: true,
          component: 'dob-modal'
        }
      })
    },
    getAccountText (account) {
      if (this.showAccountName && account?.accountName) return `| ${account.accountName}`
      if (!this.showAccountName && account?.accountDescription) return `| ${account.accountDescription}`
      return ''
    }
  },
  watch: {
    'config.accounts': {
      handler (val) {
        this.loaderEnabled = true
        if (val && val.length) {
          this.accountDetails = this.viewLess ? val : val.slice(0, 2)
        }
        this.loaderEnabled = false
      }
    }
  }
}
</script>
